import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export default function RegistrationCompleteCard({
    passwordEmailSent,
    passwordEmailSending,
    onSendPasswordEmail,
}) {
    return (
        <Box
            component="main"
            sx={{
                position: "relative",
                left: "50%",
                width: "100vw",
                ml: "-50vw",
                minHeight: "100vh",
                boxSizing: "border-box",
                bgcolor: "#f6f6f6",
                px: 2,
                py: { xs: 3, sm: 6 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "center",
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    boxSizing: "border-box",
                    width: "100%",
                    maxWidth: 520,
                    borderRadius: 2,
                    p: { xs: 3, sm: 4 },
                    textAlign: "center",
                }}
            >
                <Box
                    component="img"
                    src="/images/logo180.png"
                    alt="Nodiant"
                    sx={{
                        display: "block",
                        width: 72,
                        height: 72,
                        mx: "auto",
                        mb: 3,
                        borderRadius: 1,
                    }}
                />

                <Typography
                    component="h1"
                    sx={{
                        color: "#333333",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        fontSize: 22,
                        fontWeight: 700,
                        mb: 2,
                    }}
                >
                    Registration Completed
                </Typography>

                <Typography
                    sx={{
                        color: "#555555",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        fontSize: 15,
                        mb: 3,
                    }}
                >
                    Thank you. Your consent has been recorded.
                </Typography>

                {passwordEmailSent ? (
                    <>
                        <Alert
                            severity="success"
                            sx={{ mb: 2, textAlign: "left" }}
                        >
                            Password email sent
                        </Alert>
                        <Typography
                            sx={{
                                color: "#555555",
                                fontFamily: "Helvetica, Arial, sans-serif",
                                fontSize: 15,
                            }}
                        >
                            We have emailed you a secure link to choose your
                            password. Please check your inbox.
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography
                            sx={{
                                color: "#555555",
                                fontFamily: "Helvetica, Arial, sans-serif",
                                fontSize: 15,
                                mb: 3,
                            }}
                        >
                            To finish setting up your account, we will email you
                            a secure link to choose your password.
                        </Typography>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={onSendPasswordEmail}
                            aria-busy={passwordEmailSending}
                            sx={{
                                minHeight: 46,
                                bgcolor: "rgb(0, 149, 61)",
                                fontFamily: "Helvetica, Arial, sans-serif",
                                fontSize: 15,
                                textTransform: "none",
                                "&:hover": {
                                    bgcolor: "rgb(0, 120, 49)",
                                },
                            }}
                        >
                            {passwordEmailSending ? (
                                <>
                                    <CircularProgress
                                        size={20}
                                        color="inherit"
                                        sx={{ mr: 1 }}
                                    />
                                    Sending email…
                                </>
                            ) : (
                                "Email me a password link"
                            )}
                        </Button>
                    </>
                )}
            </Paper>
        </Box>
    );
}
